import styled from 'styled-components';

import { COLORS } from 'styles/constants';

export const Container = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const TermsText = styled.div`
  padding: 35px 50px;

  background: #fff;
  font-size: 18px;
  line-height: 16px;

  h3 {
    font-size: 32px;
  }

  h4 {
    font-size: 30px;
  }

  h3,
  h4 {
    margin-top: 30px;
    margin-bottom: 16px;
    color: ${COLORS.primary};
  }

  li {
    list-style-position: inside;
    margin-bottom: 2px;
  }

  p {
    margin: 12px 0;
    color: ${COLORS.darkBackground};
  }

  @media only screen and (max-width: 900px) {
    padding: 22px;

    h3 {
      font-size: 22px;
    }

    h4 {
      font-size: 20px;
    }

    p,
    li {
      font-size: 16px;
      line-height: 20px;
    }
  }

  @media only screen and (min-width: 1700px) {
    padding: 50px 70px;
    line-height: 25px;
  }
`;
